// extracted by mini-css-extract-plugin
export var cartContainer = "_nm-4";
export var gray = "_nm-1";
export var itemContainer = "_nm-2";
export var itemDetails = "_nm-3";
export var strong = "_nm-0";